import {BasicSelect,MultiSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import Treeselect from '@riophae/vue-treeselect';
import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import DatePicker from 'vue2-datepicker'
import CONSTANT from './../../../../shared/constants/constant';
import VueElementLoading from 'vue-element-loading';
 import createrequestedpickup from './../createrequestedpickup';
 import Util from './../../../../shared/util/util';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Multiselect from 'vue-multiselect'
import { Validator } from 'vee-validate';
import XLSX from 'xlsx';
import { time } from 'highcharts';
import utility from './../../../../utility/services/utility.service';
const moment = require('moment');
//test arc feature
export default {
  name: 'serviceareatemplate',
  components: {
    Validator,
    Multiselect,
    Treeselect,
    TripServices,
    VueElementLoading,
    DatePicker,
    createrequestedpickup,
    Pagination,
    Loader,
    CustomExpandableTable,

  },
  data: function() {
    return {
        isLoading:false,
        AWB:"",
        tableArr:[],
        companyNamelist: [],
        AssignedList: [],
        AssignedSR: null,
        companyName: null,
        shortcuts:false,
        daterange:"",
        Statuslist:[
            { id:'0', label:'Pending'},
            { id:'1', label:'Allocated'},
            { id:'2', label:'OFP'},
            { id:'3', label:'In-Progress'},
            { id:'4', label:'Fulfilled'},
            { id:'5', label:'Unpicked'},
            { id:'9', label:'Partial PRQ'},
			{ id:'Invalid', label:'Invalid'},
            // { id:'6', label:'Not fulfilled'},
          ],
          status:null,
          daaata:'',
          tableColumn: ['Req. Pickup ID','Client Name','Origin', 'Destination', 'MPS count','Physical Weight(KG)','Req.Pickup Date','Created by','Created date','Status ','Booking Mode','Pickup Instruction','AWB List','Action'],
          innerTableColumn: [],
          tableItems: [],
          currentPage: 1,
          totalPage: 0,
          totalCount:0,
          offset:0,
          requestedpickupdate:"",
          requestedpickupid:"",
          createdby:null,
          Createdbylist:[],
          pageLimit:CONSTANT.PER_PAGE_DATA,
          showCreaterequestedpickup:false,
          defaultHubID:"",
          clientname:"",
          originhub:"",
          destinationhub:"",
          destinationpincode:"",
          contactname:"",
          mobile:"",
          routemode:"",
          numberofmps:"",
          totalwt:"",
          requestedpickupdate:"",
          pickuppincode:"",
          requestedpickupcreationdate:"",
          selectedPickreqObj:[],
          ViewRequestZone:false,
          userRoleFlag: null,
          awblist:[],
          ShowAWBDetails:false,
          email:"",
          roleList:[],
          nprreasonarr:[],
          partialpickupreason:'',
          showNPR:false,
          modalData:'',
          cancelPRQID:null,
          showCancelReasonPop: false,
          cancelPRQreason:"",
          cancelPRQreasonErr:false,
          dropdownOptions: [],
          subreasonOption:[],
          reason:"",
          subReason:"",
          isChildPresent:false,
          reasondata:'P161',
          pickupcancelreason:'',
          pickupcancelsubreason:'',
          cancelPRQReasonError:'',
          cancelPRQSubReasonError:'',
          cancelPRQSubreasonErr:false,
          alternatemobile:"",
		  bookingmode:"",
		  pickupinstruction:"",
    }
  },
  
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    Promise.all([this.getRoleAccessList()])
    this.userdetail = userdetail
    this.defaultHubID = userdetail.hubID[0];
    this.userName = userdetail.email;
    this.createdby=this.userName;
    this.getRequestedPickupdata();
    this.getSRListing();
    this.getCompanyShortName();
    this.getcreatedbylist();
    await this.getuadreason();
  
  },
  methods: {
    async DownloadRequestedData(){
      try {
        this.isLoading = true;
        let inputPayload = {
          // "hubid":this.defaultHubID, //for testing use 24
        }
        if(this.requestedpickupid){
          inputPayload.pickupid = this.requestedpickupid.trim();
        }
        if(this.companyName){
          inputPayload.clientid = this.companyName.id;
        }
        if(this.status){
          inputPayload.pickuprequeststatus = this.status;
        }
        if(this.daterange[0]){
          inputPayload.requestcreateddate = this.daterange;
        }
        if(this.requeststartdate){
          inputPayload.requeststartdate = this.MPS;
        }
        if(this.AssignedSR){
          inputPayload.sruserid = this.AssignedSR;
        }
        if(this.createdby){
          inputPayload.createdby = this.createdby;
        }
        if(this.requestedpickupcreationdate){
          inputPayload.createddate = this.requestedpickupcreationdate;
        }
        if (this.userRoleFlag==1) {
          if(this.defaultHubID && !this.ViewRequestZone){
            inputPayload.hubid = this.defaultHubID
          }   
        } else {
          if(this.defaultHubID){
            inputPayload.hubid = this.defaultHubID
          }
        }
    if(this.AWB){
			inputPayload.awb =this.AWB
		}
		
        let result = await TripServices.getRequestedpickupList(inputPayload)
        if(result.data.code == 200){
         this.daaata=result;
          let tempdata = result.data.data.rows.map((el)=>{
            let invalidreson =""
            if (el.status==0) {
              if (el.reason && el.subreason) {
                invalidreson = `${el.reason} - ${el.subreason}`
              } else {
                invalidreson = el.reason
              }
            }
            return {
              'Req. Pickup ID': el.id,
              'Client Name':el.clientname,
              'Origin': el.originhub,
              'Destination':el.destinationhub,
              'MPS count':el.numberofmps,
			  'Phy Wt(KG)': el.totalwt,
              'Req.Pickup Date': Util.displayDateOnlyFormat(el.requestedpickupdate),
              'ContactNumber':el.mobile,
			  'Pickup Address':el.pickupaddress,
			  'Pickup Location':el.pickuplocation,
			  'Route Mode':el.routemode,
			  'Created by':el.createdby,
			  'Created date':Util.displayDateOnlyFormat(el.createddate),
			  'Status ': el.status == 0 ? 'Invalid' : el.pickuprequeststatus,
			  'Booking Mode':el.bookingmode,
			  'Pickup Instruction': el.pickupinstruction,
        'Comment': invalidreson,
            }
          })
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb,dt+'reuqestedpickupData.xlsx');
        }else{
          // this.totalCount = 0
          // this.tableItems = [];
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    showCreateRequested(){
    this.selectedPickreqObj = [];
     this.showCreaterequestedpickup = true;
    },
   
    callParent() {
    this.showCreaterequestedpickup = false;
    this.selectedPickreqObj = null;
    //this.currentPage = this.page;
    this.offset = 0;
    this.getRequestedPickupdata();
    },
   async getcreatedbylist(){
    try {
       var CreatedByList = [];
      let result = await TripServices.getCreatedBylist()
      if(result.data.code == 200){
        CreatedByList = result.data.data;
        for (var i = 0; i < CreatedByList.length; i++) {
          this.Createdbylist.push({
            'id': CreatedByList[i].createdby,
            'label': CreatedByList[i].createdby,
          })
       }
    }
     
    } catch (err) {
      console.log(err);
    }
   },
   searchRequest(){
      this.currentPage = 1;
      this.offset = 0;
      this.getRequestedPickupdata();
    },
 
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getRequestedPickupdata();
    },
    async getCustomTableEvent(id){
      if (id.actionType == "viewawb") {
        let payload = {
          pickupid: id.id,
        };
        let result = await TripServices.getAWBListAgainstPR(payload);
        if (result.data.code == 200) {
          this.awblist=[];
          this.ShowAWBDetails = true;
          result.data.data.map((obj) => {
            this.awblist.push(obj);
          });
        } else {
          this.$alertify.error(`No Shipment Found Against ${id.id} Pickup Request`)
        }
      }
      if(id.actionType== 'edit'){
        let selectedPickupObj  = this.tableArr.filter(function(Items) {
          return Items.id == id.id;
        });
        this.selectedPickreqObj = selectedPickupObj[0];
        this.selectedPickreqObj.action = 'edit'
        
        this.showCreaterequestedpickup = true
      }else if(id.actionType== 'view'){
        this.isLoading = true
		let selectedPickupObj  = this.tableArr.filter(function(Items) {
			return Items.id == id.id;
		});
        //let input = {
        //  id: id.id
        //}
        //let result = await TripServices.getPickupDetails(input);
        this.isLoading = false
        //if(result.data.code == 200){
        //  this.clientname = result.data.data.clientname
        //  this.originhub = result.data.data.originhub
        //  this.pickuppincode = result.data.data.pickuppincode
        //  this.destinationhub = result.data.data.destinationhub
        //  this.destinationpincode = result.data.data.destinationpincode
        //  this.contactname = result.data.data.contactname
        //  this.mobile = result.data.data.mobile
        //  this.routemode = result.data.data.routemode
        //  this.numberofmps = result.data.data.numberofmps
        //  this.totalwt = result.data.data.totalwt
        //  this.requestedpickupdate = result.data.data.requestedpickupdate
        //}
        let nprreason = selectedPickupObj[0].npr 
        let nprarr = []
        if(nprreason!= null){
          nprarr= Object.values(nprreason)
        }else{
          nprarr = []
        }
        this.nprreasonarr = []
        nprarr.forEach(el=>{
          let obj = {
            nprreason:el.nprreason,
            nprdate: Util.displayDateOnlyFormat(el.nprdate)
          }
          this.nprreasonarr.push(obj)
        })
        this.email = selectedPickupObj[0].email
        this.alternatemobile = selectedPickupObj[0].alternatemobile
	      this.clientname = selectedPickupObj[0].clientname
          this.originhub = selectedPickupObj[0].originhub
          this.pickuppincode = selectedPickupObj[0].pickuppincode
          this.destinationhub = selectedPickupObj[0].destinationhub
          this.destinationpincode = selectedPickupObj[0].destinationpincode
          this.contactname = selectedPickupObj[0].contactname
          this.mobile = selectedPickupObj[0].mobile
          this.routemode = selectedPickupObj[0].routemode
          this.numberofmps = selectedPickupObj[0].numberofmps
          this.totalwt = selectedPickupObj[0].totalwt
          this.requestedpickupdate = selectedPickupObj[0].requestedpickupdate
          this.partialpickupreason= selectedPickupObj[0].partialpickupreason == null ? '' : selectedPickupObj[0].partialpickupreason.reason
          this.pickupcancelreason= selectedPickupObj[0].reason
          this.pickupcancelsubreason= selectedPickupObj[0].subreason
		  this.bookingmode = selectedPickupObj[0].bookingmode
		  this.pickupinstruction = selectedPickupObj[0].pickupinstruction

      }
      if (id.actionType=='delete') {
        let selectedPickupObj  = this.tableArr.filter(function(Items) {
          return Items.id == id.id;
        });
        this.cancelPRQID= id.id;
        this.addCancelReason(selectedPickupObj[0]);
      }
    },
    resetFilter(){
     this.AssignedSR = null
     this.companyName = null
     this.requestedpickupid = ""
     this.AWB = ""
     this.daterange = ""
     this.createdby=this.userName;
     this.status =null
     this.requestedpickupcreationdate=""
     this.ViewRequestZone=false;
     this.showCancelReasonPop=false;
     this.cancelPRQreason=""
     this.cancelPRQreasonErr=false
     this.getRequestedPickupdata();

    },
  
    async getRequestedPickupdata(){
      try {
        this.isLoading = true;
        this.tableItems = []
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        if(this.requestedpickupid){
          inputPayload.pickupid = this.requestedpickupid.trim();
        }
        if(this.status){
          inputPayload.pickuprequeststatus = this.status;
        }
        if(this.companyName){
          inputPayload.clientid = this.companyName.id;
        }
        if(this.daterange[0]){
          inputPayload.requestcreateddate = this.daterange;
        }
        if(this.AssignedSR){
          inputPayload.sruserid = this.AssignedSR;
        }
        if(this.requestedpickupcreationdate){
          inputPayload.createddate = this.requestedpickupcreationdate;
        }
         if(this.createdby){
          inputPayload.createdby = this.createdby;
        }
		if (this.userRoleFlag==1) {
      if(this.defaultHubID && !this.ViewRequestZone){
        inputPayload.hubid = this.defaultHubID
      }   
    } else {
      if(this.defaultHubID){
        inputPayload.hubid = this.defaultHubID
      }
    }
		if(this.AWB){
			inputPayload.awb = this.AWB
		}
        let result = await TripServices.getRequestedpickupList(inputPayload)
        if(result.data.code == 200){
          this.tableArr = result.data.data.rows;
          this.totalCount = result.data.data.count;
          this.tableItems = result.data.data.rows.map((el)=>{
            return {
              'id': el.id,
              'Req. Pickup ID': el.id,
              'Client Name': el.clientname,
              'Origin': el.originhub,
              'Destination': el.destinationhub,
              'MPS count': el.numberofmps,
              'Physical Weight(KG)': el.totalwt,
              'Req.Pickup Date': el.requestedpickupdate,
              'ContactNumber': el.mobile,
              'Pickup Address': el.pickupaddress,
              'Pickup Location': el.pickuplocation,
              'Route Mode': el.routemode,
              'Created by': el.createdby,
              'Created date': Util.displayDateTimeFormat(el.createddate),
              'Status ': el.status == 0 ? 'Invalid' : el.pickuprequeststatus,
			  'Booking Mode':el.bookingmode,
              'isDeltePRQ': (el.status != 0 && el.createdby == this.userName && (el.pickuprequeststatus == 'Pending' || el.pickuprequeststatus == 'Unpicked' || el.pickuprequeststatus == 'Not fulfilled')) ? true : false,
              'isDeltePRQtitle': 'Mark PRQ Invalid',
			  'Pickup Instruction': el.pickupinstruction,
            }
          })
        }else{
          this.totalCount = 0
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    closeAWBDetails(){
      this.ShowAWBDetails = false
    },
    async getCompanyShortName() {
        try {
          var CompanyShortList = [];
          let result = await TripServices.getActiveInactiveClientList()
          CompanyShortList = result.data.data;
          for (var i = 0; i < CompanyShortList.length; i++) {
            this.companyNamelist.push({
              'id': CompanyShortList[i].ClientMasterID,
              'label': CompanyShortList[i].ClientShortName,
              'CompanyName': CompanyShortList[i].CompanyName
            })
          }
        } catch (err) {
          console.log(err);
        }
      },
      async getSRListing() {
        try {
          let InputPayload = {
            HubId: [this.defaultHubID]
          };
          let result = await TripServices.getSRList(InputPayload);
          let SRList = result.data.data;
          for (var i = 0; i < SRList.length; i++) {
            this.AssignedList.push({
              'id': SRList[i].userid,
              'label': SRList[i].srname + ' - '+ SRList[i].emptype +" " + '('+ SRList[i].userid + ')',
              'sremail': SRList[i].email
            });
          }
        } catch (err) {
          console.log(err);
        }
      },   
      isIntegerOnly: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode < 48 || charCode > 57) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
      async getRoleAccessList(){
        try{
          let input = {}
          let result = await TripServices.getPickupReqVisibilityRole(input)
          if(result.data.data.value.length > 0){
              this.userRoleFlag = result.data.data.value.includes(this.userdetail.rolename[0]) ? 1:2
          }else{
            this.userRoleFlag = 2
          }
        }catch(err){
          console.log(err);
        }
      },
      displayNPR(data){
        this.modalData=data;
        this.showNPR = true
      },
    async addCancelReason(prqdetails) {
      try {
        if (prqdetails.pickuprequeststatus != 'Pending' && prqdetails.pickuprequeststatus != 'Unpicked' && prqdetails.pickuprequeststatus != 'Not fulfilled') {
          this.$alert(`Pickup Request ${prqdetails.id} With ${prqdetails.pickuprequeststatus} Status cannot be marked Invalid.`, "", "error");
        } else if (prqdetails.createdby == this.userName) {
          this.showCancelReasonPop =  true;
        }
      } catch (error) {
        
      }
    },
    closeCancelReasonPop() {
      try {
        this.showCancelReasonPop =  false;
        this.reason="";
        this.subReason="";
        this.cancelPRQreason="";
        this.isChildPresent=false;
        this.cancelPRQreasonErr=false;
        this.cancelPRQSubreasonErr=false;
        this.cancelPRQSubReasonError="";
        this.cancelPRQReasonError=""
      } catch (error) {
        console.log(error)
      }
    },
    async cancelPRQ() {
      try {
        if (!this.reason || this.reason=="") {
          this.cancelPRQreasonErr=true;
          this.cancelPRQReasonError="Please select cancellation reason"
        }else {
          if(this.isChildPresent==true && this.subReason==''){
            this.cancelPRQSubreasonErr=true;
            this.cancelPRQSubReasonError="Please select cancellation subreason"
            
          }else{
          this.cancelPRQreason=this.reason.value+" : "+this.subReason.value
          this.cancelPRQreasonErr=false;
          let inputPayload = {
            "pickuprequestid" : `${this.cancelPRQID}`,
            "reason":this.reason.value,
            "reasoncode":this.reason.reasonCode,
            "subreason":this.subReason.value,
            "subreasoncode":this.subReason.reasonCode,
            "lastmodifiedby" : this.userName
           }
           let result = await utility.MarkPRQInvalid(inputPayload);
           this.showCancelReasonPop =  false;
           if (result.data.code==200) {
            this.$alert(`Pickup Request ${inputPayload.pickuprequestid} Marked Invalid Successfully.`, "", "success");
           } else {
            this.$alert(result.data.statusText,"Internal Server Error", "error");
           }
           this.reason="";
           this.subReason="";
           this.cancelPRQreason="";
           this.isChildPresent=false;
           this.cancelPRQreasonErr=false;
           this.cancelPRQSubreasonErr=false;
           this.cancelPRQSubReasonError=""
           this.getRequestedPickupdata();
          }
        }
      } catch (error) {
       console.log(error) 
      }
    },
    async reasonselect(data) {
      this.subreasonOption = []
      if (data.children.length !=0) {
        this.isChildPresent=true
        data.children.forEach(el => {
          this.subreasonOption.push({
            "id": el.id,
            "label": el.label,
            "value": el.value,
            "children": el.children,
            "reasonCode":el.reasonCode
          })
        })
      }else{
        this.isChildPresent=false
      }
      this.cancelPRQreasonErr=false;
    },
    subreasonselect(){
      this.cancelPRQSubreasonErr=false
    },
    async getuadreason() {
      try {
        let reArr=[]
        let chilArr=[]
        let inputPayload = {
          operationflag: this.reasondata,
        };
        let result = await TripServices.GetUADReason(inputPayload);
        if (result.data.code == 200) {
           result.data.data.forEach(dataItem => {
            let obj={
                value: dataItem.title, 
                label:dataItem.title ,
                id:1,
                children:[],
                reasonCode:dataItem.uniquecode
            }
            if (dataItem.hasOwnProperty('substatusKey')) {
              const substatusArray = dataItem[dataItem.substatusKey];
              for (let i = 0; i < substatusArray.length; i++) {
              let subObj={
                  value: substatusArray[i].title, 
                  label:substatusArray[i].title ,
                  id:1,
                  children:[],
                  reasonCode:substatusArray[i].uniquecode
                }
                chilArr.push(subObj)
              }
              obj.children=chilArr;
          } else {
              console.log("Substatus key not found in the current data item.");
          }
          reArr.push(obj)
          })
        } else {
          // alert(result.data.message);
        }
        this.dropdownOptions=reArr;
        this.isModalLoading = false;
      } catch (err) {
        console.log(err);
        this.isModalLoading = false;
      }
    },
 
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/requestedpickupgeneration/requestedpickuplist/requestedpickuplist.component.js